import AutoComplete from '../components/AutoComplete';
import Coupon from '../components/Coupon';
import { mapActions, mapState, mapMutations } from 'vuex'
import {TripTypes} from './constants.js'
import Navigation from '../components/Navigation.vue'

export default {
  name: 'Search',
  components: {
    AutoComplete,
    Coupon,
    Navigation
  },
  data: () => {
  	return {
      ...TripTypes
  	}
  },
  methods: {
    ...mapActions([
      'resetDefaultPlace',
      'tripTypeAction'
    ]),
    ...mapMutations(['formAdults', 'formKids']),
    prevRun() {
      return new Promise((resolve) => {
        // not import the result...
        this.$refs.couponRef.validateFn().finally(resolve);
      });
    }
  },
  computed: {
    ...mapState(['hasSetting', 'settings', 'form']),
    tripType: {
      get() {
        return this.$store.state.tripType;
      },
      set(value) {
        this.tripTypeAction(value);
      }
    },
    adultsSelected: {
      get() {
        return this.form.adults;
      },
      set(value) {
        this.formAdults(value);
      }
    },
    kidsSelected: {
      get() {
        return this.form.kids;
      },
      set(value) {
        this.formKids(value);
      }
    },

    logo() {
      if (this.hasSetting) {
        return this.settings.logo;
      }
      return 'https://api.btransfer.mx/uploads/btransfer-logo.png';
    }
  },
  watch: {
  }
}
